import React, { useState } from "react";
import ssoImg1 from "./../../../../assets/images/small-vessels-img.png"; // Adjust the path as necessary
import pilotIcon from "./../../../../assets/images/user-pilot-tie.svg"; // Adjust the path as necessary
import scaleIcon from "./../../../../assets/images/scale-balanced.svg"; // Adjust the path as necessary
import focusimg1 from "./../../../../assets/images/focus-img.png"; // Adjust the path as necessary
import { FaFacebookF, FaLinkedinIn, FaTwitter, FaYoutube, FaUser, FaInstagram } from 'react-icons/fa';
import { FaFilePdf } from "react-icons/fa";
import Doc1 from "./../../../../Documents/(Ref 4) Directions to CSWR.pdf";

function SeaWatchReponseOverviewTab() {
  const cardData = [
    {
      icon: pilotIcon,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardDescription: "Carry out Search and Rescue (SAR) functions & responsibilities Search and Rescue",
    },
    {
      icon: scaleIcon,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardDescription: "Implement systems for surveillance of the maritime domain – vessels safety, vessel security, oil pollution prevention, detection and combating",
    },
    {
      icon: scaleIcon,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardDescription: "Maintain MDA(Marine Domain Awareness)",
    },
    {
      icon: scaleIcon,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardDescription: "Manage Maritime Communication system for SAR requirements and radio communication with shipping",
    },
    {
      icon: pilotIcon,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardDescription: "Monitor coastal and offshore maritime activities",
    },
    {
      icon: scaleIcon,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardDescription: "Regulate coastal and inland waterways Aids to Navigation (AtoN), including Vessel Traffic Services (VTS)",
    },
    {
      icon: scaleIcon,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardDescription: "Consultation with the SA Hydrographer with regard to the annual hydrographic programme",
    },
    //   {
    //     icon: scaleIcon,
    //     shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    //     fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    //     twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    //     linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    //     instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    //     ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    //     cardDescription: "Manage Maritime Communication system for SAR requirements and radio communication with shipping",
    // },
    // {
    //     icon: pilotIcon,
    //     shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    //     fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    //     twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    //     linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    //     instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    //     ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    //     cardDescription: "Carry out Search and Rescue (SAR) functions & responsibilities Search and Rescue",
    //   },
    //   {
    //     icon: scaleIcon,
    //     shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    //     fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    //     twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    //     linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    //     instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    //     ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    //     cardDescription: "Implement systems for surveillance of the maritime domain – vessels safety, vessel security, oil pollution prevention, detection and combating",
    //   },
    //   {
    //     icon: scaleIcon,
    //     shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    //     fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    //     twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    //     linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    //     instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    //     ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    //     cardDescription: "Maintain MDA(Marine Domain Awareness)",
    //   },
    //   {
    //     icon: scaleIcon,
    //     shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    //     fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    //     twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    //     linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    //     instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    //     ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    //     cardDescription: "Manage Maritime Communication system for SAR requirements and radio communication with shipping",
    // },





  ];


  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        SEA WATCH & RESPONSE
        <span className="text-orange-ef3e33 font-400"> overview </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
          <p className="mb-3">
            SAMSA’s Centre for Sea Watch and Response (CSWR) is located in Plattekloof, Cape Town <a href={Doc1} target="_blank" rel="noopener noreferrer" className="pdf-link" >
              (See directions)</a> .
          </p>
          <p className="mb-3">
            The CSWR is the focal point in the arena of maritime domain awareness (MDA).  Its function is to monitor shipping to ensure safety of navigation and protection of the marine environment so as to protect South Africa’s maritime region
          </p>
          <p className="mb-3">
            The CSWR’s is responsible for ensuring safety of life and property at sea and the protection of the marine environment, which is the mandate of SAMSA as contained in the SAMSA Act .
          </p>

        </div>
        <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div>
        <div className="col-12">
          <p className="font-18 font-900 mb-3">CSWR core functions are:</p>

          <div className="row g-4">
            {cardData.map((card, index) => (
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6" key={index}>
                <div className="gray-card-wrap">
                  <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                    <div className="icon">
                      <img src={card.icon} alt="" />
                    </div>
                    <div className="text-center text-primary-color">
                      {card.cardDescription}
                    </div>

                    <div className="card-share">
                      {/* <button type="button" className="btn-share border-0">
                        <i className="bi bi-share"></i>
                      </button> */}
                      <ul >
                        <li>
                          <a href="#">
                            <FaFacebookF />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaTwitter />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaLinkedinIn />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaInstagram />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaYoutube />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <p className="mb-3">In executing this responsibility the Centre has divided its operations into three areas; namely Maritime Rescue Co-ordination Centre (MRCC), Intervention and Navigation.</p>
        <div className="col-12 pt-5">
          <h2 className="title-42 text-uppercase mb-4">Focus Areas</h2>

          <div className="row g-3 g-sm-4 g-md-5">
            <div className="col-12">
              <div className='focus-area-block'>
                <img src={focusimg1} className="img-fluid" alt="" />
                <div className="img-cap">
                  <h3 className="font-700 text-uppercase">Intervention</h3>
                  <p>The  Intervention section is also being developed and capacitated to respond  to situations developing at sea. This is where interaction with vessels at sea and organisations ashore are executed; through radio  communication, tasking of the Emergency Towing Vessel (ETV), initiating  the national contingency plan for specific situations, calling on  defence and other resources to assist.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className='focus-area-block'>
                <img src={focusimg1} className="img-fluid" alt="" />
                <div className="img-cap">
                  <h3 className="font-700 text-uppercase">MRCC</h3>
                  <p>The MRCC is fully functional and operates 24/7 with the focus primarily of the safety of life at sea and complies with the requirements of the DoT’s <a href="/Documents/TenderDocs/Act 5 of 2013 SASAR Amendment Act.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
                    South African Search and Rescue (SASAR) Act
                  </a>.  This entails interaction with the various government and non-government entities involved with maritime rescue at sea.​(SAR Maritime Region )
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className='focus-area-block'>
                <img src={focusimg1} className="img-fluid" alt="" />
                <div className="img-cap">
                  <h3 className="font-700 text-uppercase">Navigation</h3>
                  <p>The Navigation section is to ensure the safety of navigation in South African waters through enhancing our MDA and regulation to ensure compliance with international conventions and agreements.  It covers the regulation of Aids to Navigation (AtoN) coastal and inland waterways <a href="/services?section=watch-navigation" style={{ color: "#FFFFFF" }}>[read more]</a> , including Vessel Traffic Services (VTS), terrestrial and satellite Automatic Identification System (AIS), eNavigation (eNAV), Long range Identification and Tracking (LRIT) and oversight of Hydrography.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SeaWatchReponseOverviewTab;